import { useSyncExternalStore } from "react";
import { demoStore, type DemoSnapshot } from "./demoStore";

/** Is the demo on, and which chapter is it in. Re-renders only on change. */
export function useDemo(): DemoSnapshot {
  return useSyncExternalStore(demoStore.subscribe, demoStore.getSnapshot, demoStore.getSnapshot);
}
